import React from "react"
import { Box, Flex } from "theme-ui"
import { AiOutlineCloseCircle } from "react-icons/ai"
import { MagicLink } from "../utils/magicLink"

const Sidebar = ({ open, closed, sideBarData }) => {
  return (
    <>
      <Box
        onClick={closed}
        sx={{
          display: "block",
          position: "fixed",
          zIndex: 7999,
          top: "0",
          bottom: "0",
          right: "0",
          left: "0",
          backgroundColor: "rgba(0,0,0,0)",
          backdropFilter: open ? "blur(4px)" : "0",
          transition: "all .2s ease",
          pointerEvents: open ? "all" : "none",
          willChange: open && "opacity",
        }}
      />
      <Box
        sx={{
          display: "block",
          boxSizing: "border-box",
          position: "fixed",
          width: ["390px", "50%"],
          maxWidth: "70%",
          height: "100%",
          right: "0",
          top: "0",
          backgroundColor: "#ffffff",
          overflow: "auto",
          zIndex: 2147483636,
          transition: "transform 200ms 0s",
          transitionProperty: "transform,visibility,width",
          transform: open ? "translateX(0)" : "translateX(100%)",
          visibility: open ? "" : "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            right: [3, 4],
            top: [8],
          }}
          onClick={closed}
        >
          <AiOutlineCloseCircle size={40} />
        </Box>
        <Flex
          sx={{
            flexDirection: "column",
            py: [4, 6],
            px: [8],
            height:"100%",
            justifyContent: "space-between",
          }}
        >
          <Box>
            {sideBarData &&
              sideBarData.map((menuItem, index) => (
                <Box>
                  <MagicLink
                    sx={{
                      color: "text",
                      fontSize: [8],
                      fontWeight: "300",
                      lineHeight: "88px",
                      textDecoration: "none",
                      "&:hover": {
                        color: "primary",
                      },
                    }}
                    item={menuItem.link}
                  >
                    {menuItem.achor}
                  </MagicLink>
                </Box>
              ))}
          </Box>
          <Box>
            <Box
              sx={{
                a: {
                  color: "dark",
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                },
              }}
              dangerouslySetInnerHTML={{
                __html: `<h2>MECMATICA SRL</h2>
<p>Via Campo Romano 13, 24050<br />Spirano (BG) <a href="tel:035320144">Tel. 035-320144</a></p>`,
              }}
            />
          </Box>
        </Flex>
      </Box>
    </>
  )
}

export default Sidebar
